<template>
  <div class="text-xs-right">
    <v-menu offset-y>
      <template #activator="{ on }">
        <v-btn flat :color="light ? 'light' : 'primary'" v-on="on">{{ locale }} <v-icon>arrow_drop_down</v-icon></v-btn>
      </template>
      <v-list>
        <v-list-tile v-for="(lang, code) in languages" :key="code" @click="setLocale(code)">
          <v-list-tile-title>{{ lang.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    light: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    languages: {
      ru: {
        title: 'Русский язык',
      },
      kz: {
        title: 'Қазақ тілі',
      },
    },
  }),
  computed: {
    locale () {
      return this.$i18n.locale
    },
  },
  methods: {
    setLocale (locale) {
      this.$i18n.locale = locale
      localStorage.setItem('rating-locale', locale)
    }
  },
}
</script>
